import { render, staticRenderFns } from "./LegalPersonInput.vue?vue&type=template&id=458ff6f5&scoped=true"
import script from "./LegalPersonInput.vue?vue&type=script&lang=js"
export * from "./LegalPersonInput.vue?vue&type=script&lang=js"
import style0 from "./LegalPersonInput.vue?vue&type=style&index=0&id=458ff6f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ff6f5",
  null
  
)

export default component.exports